import AuthPage from '../../AuthPage';

function AdminGirisPage() {
  return (
    <AuthPage 
      role="admin"
      title="Admin Login"
      icon="🛠️"
      redirectPath="/admin"
    />
  );
}

export default AdminGirisPage;